import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { formValueSelector, reduxForm } from 'redux-form';

import { compose } from '../../utils';
import { saving, types } from '../../redux/article/selectors';
import { list, defaultLang } from '../../redux/lang/selectors';
import { getListAdmin as getCategoriesRelations } from '../../redux/materials-category-type/actions';
import { listAdmin as categoriesRelations } from '../../redux/materials-category-type/selectors';
import { getListAdmin as getCategoryTypesList } from '../../redux/category-type/actions';
import { listAdmin as categoryTypes } from '../../redux/category-type/selectors';
import { getListByDoctype } from '../../redux/category/actions';

import ArticleForm from './ArticleForm';

const formConect = reduxForm({
  form: 'article',
  enableReinitialize: true,
});

const values = formValueSelector('article');

const reduxConect = connect(
  createStructuredSelector({
    saving,
    langList: list,
    defaultLang,
    types,
    categoriesRelations,
    categoryTypes,
    relatedValues: state => values(state, 'related'),
    selectedSubType: state => values(state, 'subType'),
    langData: state => values(state, 'lang'),
  }),
  {
    getCategoriesRelations,
    getCategoryTypesList,
    getListByDoctype,
  },
);

export { ArticleForm };

export default compose(reduxConect, formConect)(ArticleForm);
